import React, { FC } from 'react';
import { HStack, Text } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { MdOutlineRadioButtonUnchecked } from 'react-icons/md';

interface Props {
  label: string;
  isCompleted: boolean;
  hideStatus?: boolean;
}

export const AddLiquiditySectionTitle: FC<Props> = ({
  label,
  isCompleted,
  hideStatus
}) => {
  return (
    <HStack
      bg="gray.2"
      borderRadius={4}
      w="100%"
      justifyContent="space-between"
      p={4}
    >
      <Text fontSize={16}>{label}</Text>
      {!hideStatus && (
        <>
          {isCompleted ? (
            <CheckIcon color="success" width={4} height={4} />
          ) : (
            <MdOutlineRadioButtonUnchecked color="var(--chakra-colors-neutral-500)" />
          )}
        </>
      )}
    </HStack>
  );
};
